const COLORS = {
  primary: '#09529f',
  primaryDark: '#002348',
  success: '#28a745',
  danger: '#dc3545',
  dangerBg: '#f8d7da',
  dangerBorder: '#f5c6cb',
  white: '#fff',
  lightGray: '#f8f9fa',
  borderGray: '#dee2e6',
  textGray: '#666',
  appBackground: '#F0F8FF'
};

export const loginFormStyles = {
  // ページ全体のコンテナ
  pageContainer: {
    minHeight: '80vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.appBackground,
    padding: '20px'
  },

  // メインコンテナ
  container: {
    maxWidth: '400px',
    width: '100%',
    backgroundColor: COLORS.white,
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    border: `2px solid ${COLORS.primary}`
  },

  // タイトル
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: COLORS.primary,
    textAlign: 'center',
    marginBottom: '30px',
    borderBottom: `3px solid ${COLORS.primary}`,
    paddingBottom: '15px'
  },

  // フォーム
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },

  // フィールドグループ
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  // ラベル
  label: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '5px'
  },

  // 必須マーク
  required: {
    color: COLORS.danger,
    marginLeft: '3px'
  },

  // 入力フィールド
  input: {
    width: '100%',
    padding: '12px 16px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: COLORS.borderGray,
    borderRadius: '6px',
    fontSize: '16px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
    backgroundColor: COLORS.white,
    outline: 'none'
  },

  // 入力フィールド（フォーカス時）
  inputFocus: {
    borderColor: COLORS.primary,
    boxShadow: `0 0 0 2px rgba(9, 82, 159, 0.1)`
  },

  // 入力フィールド（エラー時）
  inputError: {
    borderColor: COLORS.danger,
    boxShadow: `0 0 0 2px rgba(220, 53, 69, 0.1)`
  },

  // パスワード入力コンテナ
  passwordContainer: {
    position: 'relative'
  },

  // パスワード表示/非表示ボタン
  passwordToggle: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: COLORS.textGray,
    fontSize: '16px',
    padding: '4px'
  },

  // エラーメッセージ
  errorMessage: {
    color: COLORS.danger,
    fontSize: '14px',
    marginTop: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },

  // ログインボタン
  loginButton: {
    width: '100%',
    padding: '14px',
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '10px'
  },

  // ログインボタン（ホバー時）
  loginButtonHover: {
    backgroundColor: COLORS.primaryDark,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(9, 82, 159, 0.2)'
  },

  // ログインボタン（無効時）
  loginButtonDisabled: {
    backgroundColor: COLORS.textGray,
    cursor: 'not-allowed',
    opacity: 0.6
  },

  // ローディングスピナー
  loadingSpinner: {
    width: '16px',
    height: '16px',
    border: '2px solid transparent',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginRight: '8px'
  },

  // リンク
  link: {
    color: COLORS.primary,
    textDecoration: 'none',
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '20px',
    cursor: 'pointer',
    transition: 'color 0.3s ease'
  },

  linkHover: {
    color: COLORS.primaryDark,
    textDecoration: 'underline'
  },

  // 区切り線
  divider: {
    margin: '30px 0',
    textAlign: 'center',
    position: 'relative',
    color: COLORS.textGray,
    fontSize: '14px'
  },

  dividerLine: {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    height: '1px',
    backgroundColor: COLORS.borderGray,
    zIndex: 0
  },

  dividerText: {
    backgroundColor: COLORS.white,
    padding: '0 15px',
    position: 'relative',
    zIndex: 1
  },

  // 新規登録へのリンクコンテナ
  registerContainer: {
    textAlign: 'center',
    marginTop: '30px',
    padding: '20px',
    backgroundColor: COLORS.lightGray,
    borderRadius: '6px',
    border: `1px solid ${COLORS.borderGray}`
  },

  registerText: {
    color: COLORS.textGray,
    fontSize: '14px',
    marginBottom: '10px'
  },

  registerButton: {
    color: COLORS.primary,
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'color 0.3s ease'
  }
};

// CSS アニメーション
export const loginFormAnimations = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
    20%, 40%, 60%, 80% { transform: translateX(2px); }
  }
`;

// ユーティリティ関数
export const loginFormUtils = {
  // ボタンの状態に応じたスタイルを取得
  getButtonStyle: (isLoading, isDisabled) => {
    let style = { ...loginFormStyles.loginButton };

    if (isDisabled) {
      style = { ...style, ...loginFormStyles.loginButtonDisabled };
    }

    return style;
  },

  // 入力フィールドの状態に応じたスタイルを取得
  getInputStyle: (hasError, isFocused) => {
    let style = { ...loginFormStyles.input };

    if (hasError) {
      style = { ...style, ...loginFormStyles.inputError };
    } else if (isFocused) {
      style = { ...style, ...loginFormStyles.inputFocus };
    }

    return style;
  },

  // エラーメッセージのスタイルを取得
  getErrorMessageStyle: () => loginFormStyles.errorMessage
};